import HeadingOverrides from './Blocks/Overrides/Heading';

HeadingOverrides();
